import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { D365MaintenanceResponse } from '@app/core/models/dto/gateway-midleware/d365-gateway-maintain-response';
import { D365MaintenanceRequest } from '@app/core/models/dto/gateway-midleware/d365-gateway-maintain-request';


/**
 * This SystemService class is an Angular service 
 * that provides methods for interacting with a D365 gateway API for maintenance mode management.
 */
@Injectable({
  providedIn: 'root'
})
export class SystemService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly baseUrl: string = environment.gateway.url;
  private readonly maintenanceStatusEndpoint: string = environment.gateway.segments.maintenance;
  private readonly maintenanceEndpoint: string = `${this.baseUrl}${this.maintenanceStatusEndpoint}`;


  
  /**
   * Retrieves the current maintenance mode status from the D365 gateway.
   * @returns An Observable of D365MaintenanceResponse containing the maintenance mode status.
   */
  getMaintenanceStatus(): Observable<D365MaintenanceResponse> 
  {
    return this.http.get<D365MaintenanceResponse>(this.maintenanceEndpoint);
  }


  /**
   * Sets the maintenance mode status for the application.
   * @param isMaintenance True to enable maintenance mode, false to disable.
   * @returns An Observable that emits the response data from the gateway.
   */
  setMaintenanceMode(isMaintenance: boolean): Observable<D365MaintenanceResponse> {
    const request: D365MaintenanceRequest = { isMaintenance: isMaintenance };
    return this.http.post<D365MaintenanceResponse>(this.maintenanceEndpoint, request);
  }

}


